import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import Img from 'gatsby-image';
import CloseIcon from '@material-ui/icons/Close';
import Sticker1 from '../../static/images/avatar-of-man-with-laptop-showing-thumbs-up.png';

export default function SpecialistContactYouModal({ isOpen, handleClose, handleConfirm }) {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          width: '480px',
        },
      }}
    >
      <DialogTitle
        style={{
          height: '120px', backgroundColor: '#c3e7ff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}
        id="alert-dialog-title"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <Typography style={{
          color: '#4aa4db', textAlign: 'center', textAlignLast: 'center', fontWeight: 'bold',
        }}
        >
          {' '}
          AGORA É COM A GENTE!
        </Typography>
        <Typography style={{ color: '#8ca3b5' }}> Logo um especialista entrará em contato com você </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ display: 'flex', justifyContent: 'center', minHeight: '240px' }} id="alert-dialog-description">
          <img
            src={Sticker1}
            alt=""
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              bottom: '0',
              height: '305px',
              width: 'auto',
            }}
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
